import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Copy } from 'lucide-react';
import { getAuthHeaders } from '../../../contexts/AuthContext';
import { API } from '../execShared';

export default function ReferralSection() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/referrals/my-link`, { headers: getAuthHeaders() }).then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const copyLink = () => {
    if (data?.link) { navigator.clipboard.writeText(data.link); setCopied(true); setTimeout(() => setCopied(false), 2000); }
  };

  if (loading) return <p className="text-[#9CA3AF]">Loading...</p>;
  if (!data) return <p className="text-[#6B7280]">Referral program not available.</p>;

  return (
    <div className="space-y-6" data-testid="referral-section">
      <h2 className="font-display text-2xl font-bold">Refer + <span className="text-[#FF4343]">Earn</span></h2>

      {/* Link */}
      <div className="bg-[#111827] border border-white/10 p-6 border-l-[3px] border-l-[#FF4343]">
        <p className="text-xs text-[#9CA3AF] mb-3">Share your referral link and earn when people join and activate.</p>
        <div className="flex gap-2 mb-4">
          <input readOnly value={data.link} className="flex-1 px-3 py-2.5 bg-[#090E33] border border-white/10 text-white text-sm font-mono" data-testid="referral-link-input" />
          <button onClick={copyLink} data-testid="copy-referral-btn"
            className="border-2 border-[#FF4343] text-[#FF4343] hover:bg-[#FF4343] hover:text-[#090E33] px-4 py-2 text-sm font-medium transition-all flex items-center gap-1.5">
            <Copy className="w-3.5 h-3.5" /> {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <p className="text-[10px] text-[#6B7280] font-mono">Code: {data.code}</p>
      </div>

      {/* Rewards */}
      {data.rewards?.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {data.rewards.map((r, i) => (
            <div key={i} className="bg-[#111827] border border-white/10 p-4">
              <span className="font-mono text-2xl font-bold text-[#FF4343]">${r.reward_amount}</span>
              <p className="text-xs text-[#9CA3AF] mt-1">{r.referral_type?.replace(/_/g, ' ')}</p>
              <p className="text-[9px] text-[#6B7280] mt-1">When: {r.qualifying_action?.replace(/_/g, ' ')}</p>
            </div>
          ))}
        </div>
      )}

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-[#111827] border border-white/10 p-5 text-center">
          <span className="font-mono text-3xl font-bold text-white">{data.referrals?.length || 0}</span>
          <p className="text-[9px] text-[#6B7280] font-mono uppercase mt-1">Referrals</p>
        </div>
        <div className="bg-[#111827] border border-white/10 p-5 text-center">
          <span className="font-mono text-3xl font-bold text-[#FF4343]">${(data.total_earned || 0).toLocaleString()}</span>
          <p className="text-[9px] text-[#6B7280] font-mono uppercase mt-1">Total Earned</p>
        </div>
      </div>

      {/* Referrals Table */}
      {data.referrals?.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="referrals-table">
            <thead><tr className="border-b border-white/10">
              {['Email','Type','Status','Reward','Date'].map(h => <th key={h} className="text-left py-2 text-[#6B7280] font-mono text-[10px] uppercase">{h}</th>)}
            </tr></thead>
            <tbody>
              {data.referrals.map(r => (
                <tr key={r.id} className="border-b border-white/5">
                  <td className="py-2 text-white text-xs">{r.referred_email || '—'}</td>
                  <td className="py-2 text-[#6B7280] text-xs capitalize">{r.referred_type}</td>
                  <td className="py-2"><span className={`text-[10px] font-mono uppercase ${r.status === 'paid' ? 'text-[#10B981]' : r.status === 'qualified' ? 'text-[#FF4343]' : 'text-[#9CA3AF]'}`}>{r.status}</span></td>
                  <td className="py-2 font-mono text-xs text-[#FF4343]">{r.reward_amount ? `$${r.reward_amount}` : '—'}</td>
                  <td className="py-2 text-[#6B7280] text-xs">{r.created_at ? new Date(r.created_at).toLocaleDateString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


